import React from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { sendRiqueConversationEmail } from '@/lib/riqueApi';
import { toast } from 'react-hot-toast';

interface RiqueEmailDialogProps {
  isOpen: boolean;
  onClose: () => void;
  conversationId: string | null;
  companyId?: string;
  defaultEmail?: string;
}

export const RiqueEmailDialog: React.FC<RiqueEmailDialogProps> = ({
  isOpen,
  onClose,
  conversationId,
  companyId,
  defaultEmail = '',
}) => {
  const [email, setEmail] = React.useState(defaultEmail);
  const [sending, setSending] = React.useState(false);

  React.useEffect(() => {
    if (isOpen) setEmail(defaultEmail);
  }, [isOpen, defaultEmail]);

  const handleSend = async () => {
    if (!conversationId) return;
    const to = email.trim();
    if (!to || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to)) {
      toast.error('Informe um e-mail válido.');
      return;
    }
    setSending(true);
    try {
      await sendRiqueConversationEmail(conversationId, to, companyId || undefined);
      toast.success(`Conversa enviada para ${to}`);
      onClose();
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Falha ao enviar e-mail.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Enviar conversa por e-mail" size="sm" zIndex={10001}>
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          O relatório será enviado com a identidade visual Zeh Motoca / PortalFly.
        </p>
        <div className="space-y-2">
          <label htmlFor="rique-email-to" className="text-sm font-medium text-foreground">
            Destinatário
          </label>
          <Input
            id="rique-email-to"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@empresa.com"
            disabled={sending}
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={sending}>
            Cancelar
          </Button>
          <Button type="button" onClick={() => void handleSend()} disabled={sending || !conversationId}>
            {sending ? 'Enviando…' : 'Enviar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
